// Filename - GlobalShareContext.tsx
import React, { createContext, useState, useContext, ReactNode } from "react";

interface ShareData {
  text: string;
  url: string;
  title: string;
}

interface GlobalShareContextProps {
  shareData: ShareData | null;
  showShareModal: boolean;
  share: (data: ShareData) => void;
  resetShare: () => void;
}

const GlobalShareContext = createContext<GlobalShareContextProps | undefined>(
  undefined
);

interface GlobalShareProviderProps {
  children: ReactNode;
}

export const GlobalShareProvider: React.FC<GlobalShareProviderProps> = ({
  children,
}) => {
  const [shareData, setShareData] = useState<ShareData | null>(null);
  const [showShareModal, setShowShareModal] = useState(false);

  const share = (data: ShareData) => {
    setShareData(data);
    setShowShareModal(true);
  };

  const resetShare = () => {
    setShareData(null);
    setShowShareModal(false);
  };

  return (
    <GlobalShareContext.Provider
      value={{ shareData, showShareModal, share, resetShare }}
    >
      {children}
    </GlobalShareContext.Provider>
  );
};

export const useGlobalShare = (): GlobalShareContextProps => {
  const context = useContext(GlobalShareContext);
  if (context === undefined) {
    throw new Error("useGlobalShare must be used within a GlobalShareProvider");
  }
  return context;
};
